import React, { Component } from 'react';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';

import { Auth, Http } from '../../../support';
import Loading from '../../../facturotopia/loading/Loading';
import ReceptorResetPassword from './ReceptorResetPassword';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import ReceptorFiscalInfoForm from '../../../app/receptores/upsert/components/ReceptorFiscalInfoForm';

class ReceptorUserProfile extends Component {

  state = {
    data: {}
  }

  constructor(props) {
    super(props);

    const data = Auth.getUser();

    this.state ={
      data: {
        razon_social: data.nombre,
        rfc: data.rfc,
        email: data.email,
        telefono: data.telefono,
        uso_cfdi: data.uso_cfdi,
        regimen: data.regimen,
        cp: data.direccion.cp
      }
    };
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
        return;
    };
}

  handleOnChange = (event) => {
    const { data, step, isValid } = event;

    const newData = {
      data: {
        ...data,
        direccion: {
          cp: data.cp
        }
      }
    }

    this.setState({
      ...newData,
      step,
      isValid,
      error: undefined,
      result: undefined
    });
  }

  handleOnSubmit = async () => {
    const { data } = this.state;

    this.setState({
      busy: true,
      error: undefined
    });

    let response;

    try {
      const headers = {
        'X-Tenancy': 'fa/live'
      }

      const params = {
        include: ['cliente', 'empresa', 'roles']
      }

      const body = {
        ...data,
      }

      response = await Http.put(`ext/receptores/me`, body, {
        headers,
        params
      });

      this.setState({
        response
      });
    } catch (error) {
      this.setState({
        error: error.data || error
      });
    } finally {
      this.setState({
        busy: false
      });
    }

    if (!!response && !!this.props.onComplete) {
      this.props.onComplete(response);
    }
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.setState({
        error: undefined
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          variant="inline"
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { data, isValid, busy, error, response } = this.state;

    if (!data && !data.nombre) {
      return <Loading />
    }

    return (
      <>
        <div className="mb-4">
          <strong className="text-info">INFORMACIÓN PERSONAL</strong>
        </div>

        <Row>
          <Col xs={ 12 } sm={ 12 } md={ 6 } lg={ 5 }>
            <ReceptorFiscalInfoForm
              data={ data }
              datos_fiscales_requeridos={ true }
              onFormDataChange={ this.handleOnChange }
              onAction={ this.handleOnAction }
            />
          </Col>
        </Row>

        <div className="py-4"></div>

        <div className="mb-4">
          <strong className="text-info">CAMBIAR CONTRASEÑA</strong>
        </div>

        <Row>
          <Col>
            <p className="text-muted">Por seguridad, la contraseña debe contener una mayúscula, un número y un caracter especial ($%&#.?¡@/)</p>
          </Col>
        </Row>

        <Row>
          <Col xs={ 12 } sm={ 12 } md={ 6 } lg={ 5 }>
            <ReceptorResetPassword
              data={ data }
              onFormDataChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        { !!response && (
            <p className="text-info">
              Actualizado por última vez a las { moment(response.data.updated_at).format('hh:mm:ss A') }
            </p>
          )
        }

        { !!error && this.renderError() }

        <div>
          <LoadingButton
            disabled={ busy || !isValid }
            loading={ busy }
            onClick={ this.handleOnSubmit }
          >
            Guardar
          </LoadingButton>
        </div>
      </>
    );
  }
}


export default ReceptorUserProfile;